import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import { localeEn as userEn } from '@next-qr/module-user/web';
import { localeEn as orgEn } from '@next-qr/module-organization/web';
import { localeEn as subscriptionEn } from '@next-qr/module-subscription/web';
import { localeEn as mailEn } from '@next-qr/module-mail/web';
import { localeEn as chatEn } from '@next-qr/module-chat/web';

const enTranslation = { ...en, ...userEn, ...orgEn, ...subscriptionEn, ...mailEn, ...chatEn };

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
